import { render, staticRenderFns } from "./privacy-terms-content.vue?vue&type=template&id=409f53e0&scoped=true"
import script from "./privacy-terms-content.vue?vue&type=script&lang=js"
export * from "./privacy-terms-content.vue?vue&type=script&lang=js"
import style0 from "./privacy-terms-content.vue?vue&type=style&index=0&id=409f53e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f53e0",
  null
  
)

export default component.exports